import React, { useEffect, useState } from "react"
import DataTable from "react-data-table-component"
import Modal from "react-bootstrap/Modal"
import { Navigate } from "react-router-dom"
import * as moment from "moment"
import { getCookie } from "../../utils/cookies"
import { GetBetsPerAgent, GetBets } from "../../services/AcceptedBetsServices"
import { buildTicketImageDataUrl } from "../../utils/ticketPrint"
import matik_urovo from "../../img/logo-lottomatik.png"
import logo3d_urovo from "../../img/logo-3d.jpg"
import "../../css/AcceptedBets.css"

const AcceptedBets = () => {
  const user = getCookie("usercode")
  const todayDatedata = moment().format("yyyy-MM-DD")
  const [acceptedbets, setAcceptedbets] = useState([])
  const [betsclick, setBetsclick] = useState([])
  const [selectedtrans, setSelectedTrans] = useState(null)
  const [selectedTransactionRow, setSelectedTransactionRow] = useState(null)
  const [timeselected, setTimeSelected] = useState("ALL")

  const peso = (value) => `₱${Number(value || 0).toFixed(2)}`

  const postToRN = (payload) => {
    try {
      if (!window.ReactNativeWebView?.postMessage) return false
      window.ReactNativeWebView.postMessage(JSON.stringify(payload))
      return true
    } catch (error) {
      console.log("postToRN failed", error)
      return false
    }
  }

  const formatReceiptDate = (value) => {
    const parsed = moment(value)
    return parsed.isValid() ? parsed.format("YYYY/MM/DD ddd HH:mm") : ""
  }

  const formatDrawDate = (value, drawcode) => {
    const parsed = moment(value)
    const date = parsed.isValid() ? parsed.format("YYYY/MM/DD ddd") : ""
    const drawTime = String(drawcode || "").match(/(11AM|2PM|4PM|5PM|8PM|9PM)/i)?.[1]
    const time = drawTime ? moment(drawTime, "hA").format("HH:mm") : ""
    return [date, time].filter(Boolean).join(" ")
  }
  const [grosstotal, setTotalGross] = useState(0)
  const [modalShow, setModalShow] = useState(false)
  const [isLoadingList, setIsLoadingList] = useState(false)
  const [isLoadingDetail, setIsLoadingDetail] = useState(false)
  const [isPrinting, setIsPrinting] = useState(false)
  const [currentTime, setCurrentTime] = useState(() => moment())

  const isBetOlderThanFiveMinutes = (value) => {
    const betDate = moment(value)
    return (
      betDate.isValid() &&
      currentTime.valueOf() >= betDate.clone().add(5, "minutes").valueOf()
    )
  }

  const isReprintDisabled =
    isLoadingDetail ||
    isPrinting ||
    !betsclick.length ||
    isBetOlderThanFiveMinutes(selectedTransactionRow?.drawdate)

  const betscolumns = [
    { name: "Draw", selector: (row) => row.drawcode, grow: 1 },
    { name: "Combination", selector: (row) => row.combination, grow: 1.4 },
    { name: "Bet", selector: (row) => row.betamount, right: true },
  ]

  const columns = [
    { name: "Transaction", selector: (row) => row.transactionid, wrap: true, grow: 1.5 },
    { name: "Draw date", selector: (row) => formatReceiptDate(row.drawdate), center: true, grow: 1.2 },
    { name: "Gross", selector: (row) => row.totalbet, right: true },
  ]

  const tableStyles = {
    headCells: { style: { paddingLeft: "7px", paddingRight: "7px" } },
    cells: { style: { paddingLeft: "7px", paddingRight: "7px" } },
  }

  const DrawTime = () => ["ALL", "2PM", "5PM", "9PM"]

  const LoadBets = async (selectedTime = timeselected, selectedGame = "3D") => {
    try {
      setIsLoadingList(true)
      const result = await GetBetsPerAgent({
        usercode: getCookie("usercode"),
        date: todayDatedata,
        drawtime: selectedTime,
        game: selectedGame,
      })
      const safeResult = Array.isArray(result) ? result : []
      setAcceptedbets(safeResult)
      setTotalGross(safeResult.length !== 0 ? safeResult[0].Grosstotal || 0 : 0)
    } catch (error) {
      console.log(error)
      setAcceptedbets([])
      setTotalGross(0)
    } finally {
      setIsLoadingList(false)
    }
  }

  const onClickBet = async (row) => {
    setSelectedTrans(row.transactionid)
    setSelectedTransactionRow(row)
    setBetsclick([])
    setModalShow(true)
    setIsLoadingDetail(true)
    try {
      const result = await GetBets({
        usercode: getCookie("usercode"),
        date: todayDatedata,
        transactionid: row.transactionid,
      })
      const detailRows = Array.isArray(result) ? result : []
      setBetsclick(detailRows)
      setSelectedTransactionRow((current) => ({
        ...current,
        ...row,
        qrvalue: row.qrvalue || detailRows[0]?.qrvalue || "",
      }))
    } catch (error) {
      console.log(error)
      setBetsclick([])
    } finally {
      setIsLoadingDetail(false)
    }
  }

  const handleReprint = async () => {
    if (isPrinting || isLoadingDetail || !selectedtrans || !betsclick.length) return

    setIsPrinting(true)
    try {
      const betsForPrint = betsClickToPrint(betsclick)
      const total = betsclick.reduce((sum, bet) => sum + Number(bet.betamount || 0), 0)
      const firstBet = betsclick[0]
      const qrText = selectedTransactionRow?.qrvalue || betsclick[0]?.qrvalue || ""
      if (!qrText) {
        throw new Error("The original QR value is unavailable for this transaction.")
      }
      const meta = {
        ticketNumber: selectedtrans,
        ticketPrice: peso(total),
        betDate: formatReceiptDate(selectedTransactionRow?.drawdate),
        drawDate: formatDrawDate(selectedTransactionRow?.drawdate, firstBet?.drawcode),
        drawId: firstBet?.drawid || selectedTransactionRow?.drawid || "",
        agentId: getCookie("usercode"),
        qrText,
      }

      const imageDataUrl = await buildTicketImageDataUrl({
        meta,
        bets: betsForPrint,
        assets: { logoLeftSrc: logo3d_urovo, logoRightSrc: matik_urovo },
        paperWidth: 384,
      })
      const printed = postToRN({
        type: "TEST_PRINT",
        text: "",
        imageBase64: imageDataUrl,
        align: "left",
        imageWidth: 384,
        feedLines: 12,
      })

      if (!printed) {
        window.alert("Printing only works inside Urovo WebView app.")
      }
    } catch (error) {
      console.log("Reprint failed", error)
      window.alert("Unable to reprint this transaction.")
    } finally {
      setIsPrinting(false)
    }
  }

  const betsClickToPrint = (rows) => rows.map((bet, index) => ({
    type: bet.drawcode,
    label: String.fromCharCode(65 + index),
    numbers: String(bet.combination || ""),
    price: peso(bet.betamount),
  }))

  const handleTimeChange = (value) => {
    setTimeSelected(value)
    LoadBets(value, "3D")
  }

  useEffect(() => {
    LoadBets("ALL", "3D")
  }, [])

  useEffect(() => {
    const timer = window.setInterval(() => setCurrentTime(moment()), 1000)
    return () => window.clearInterval(timer)
  }, [])

  if (!user) return <Navigate to="/" replace />

  return (
    <main className="accepted-page">
      <div className="accepted-shell">
        <header className="accepted-header">
          <div>
            <span className="accepted-eyebrow">Today&apos;s activity</span>
            <h1>Accepted bets</h1>
          </div>
          <span className="accepted-agent">{user}</span>
        </header>

        <section className="accepted-card accepted-summary">
          <div>
            <span className="accepted-summary-label">Total gross</span>
            <strong className="accepted-total">₱{Number(grosstotal || 0).toFixed(2)}</strong>
          </div>
          <select
            className="accepted-filter-select"
            aria-label="Filter activity"
            value={timeselected}
            onChange={(event) => handleTimeChange(event.target.value)}
          >
            {DrawTime().map((row) => (
              <option key={row} value={row}>
                {row}
              </option>
            ))}
          </select>
        </section>

        <section className="accepted-card accepted-list-card">
          <div className="accepted-list-heading">
            <h2>Transactions</h2>
          </div>
          <div className="accepted-table-wrap">
            <DataTable
              className="accepted-data-table"
              columns={columns}
              data={acceptedbets}
              onRowClicked={onClickBet}
              highlightOnHover
              pointerOnHover
              progressPending={isLoadingList}
              persistTableHead
              paginationPerPage={4}
              paginationRowsPerPageOptions={[4]}
              pagination
              customStyles={tableStyles}
              noDataComponent={<div className="accepted-empty"><strong>No accepted bets</strong>No transactions match this filter.</div>}
            />
          </div>
        </section>
      </div>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="sm"
        centered
        aria-labelledby="accepted-detail-title"
        dialogClassName="accepted-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="accepted-detail-title">{selectedtrans}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoadingDetail ? (
            <div className="accepted-empty">Loading bet details…</div>
          ) : (
            <DataTable
              columns={betscolumns}
              data={betsclick}
              highlightOnHover
              paginationPerPage={4}
              paginationRowsPerPageOptions={[4]}
              fixedHeader
              pagination
              customStyles={tableStyles}
              noDataComponent={<div className="accepted-empty">No bet details found.</div>}
            />
          )}
        </Modal.Body>
        <Modal.Footer className="accepted-modal-footer">
          <button
            type="button"
            className="accepted-reprint-button"
            onClick={handleReprint}
            disabled={isReprintDisabled}                             title={isBetOlderThanFiveMinutes(selectedTransactionRow?.drawdate) ? "Reprint is unavailable after 5 minutes." : "Reprint ticket"}
            aria-label={`Reprint transaction ${selectedtrans || ""}`}
          >
            {isPrinting ? "Printing…" : "Reprint"}
          </button>
        </Modal.Footer>
      </Modal>
    </main>
  )
}

export default AcceptedBets
